module.exports = {
  App: {
    name: 'Name',
    number: 'Number',
    phone: 'Phone',
    sms: 'SMS',
    email: 'E-mail',
    id: 'ID',
    done: 'Done',
    close: 'Close',
    floor: 'Floor',
    company: 'Organization',
    position: 'Position',
    remarks: 'Remarks',
    password: 'Password',
    account: 'Account',
    delete: 'Delete',
    placeholder: {
      text1: 'search by account name',
      text2: 'search by logs description',
      text3: 'search by name',
      text4: 'Please enter the keyword search',
    },
    login: {
      text1: 'Welcome to inhealth!',
      text2: 'Happiness and healthiness',
      text3: 'Please enter your log-in name',
      text4: 'Please enter your password',
      text5: 'Please enter the verification code',
      text6: 'Sign in',
      text7: 'Forgot password',
      text8: 'Remember password',
    },
    retrievePassword: {
      text1: 'Forgot password',
      text2: 'Log-in name',
      text3: 'Verification code',
      text4: '*An email will be sent to you automatically for renewing a new password',
      text5: 'New password:',
      text6: 'E-mail verification code:',
      text7: 'Send',
    },
    header: {
      text1: 'Sign Out',
      text2: 'Country',
      text3: 'Province',
      text4: 'City',
      text5: 'Hotel',
      text6: 'Site',
    },
    grouping: {
      text1: '分组列表'
    },
    sideBar: {
      text1: 'Dashboard',
      text2: 'Areas',
      text3: 'Classroom lights',
      text4: 'Blackboard lights',
      text5: 'Switch panel',
      text6: 'Curtain',
      text7: 'Lights',
      text8: 'HCL lights',
      text15: 'AQ sensors',
      text9: 'Air purifiers',
      text10: 'InGate',
      text11: 'Alert management',
      text12: 'User activity',
      text13: 'User management',
      text14: 'Site management',
      text16: 'School',
      text17: 'School management',
      text18: 'UV lights',

      text19: 'Project area',
      text20: 'Air quality',
      text21: 'Triliros sterilizer',
      text22: 'Project management',
      text23: 'Group',
      text24: 'Plant lights',
    },
    dashboard: {
      text1: 'Hotel Data',
      text2: 'No.of Rooms',
      text3: 'No.of Air Purifiers',
      text4_1: 'No.of AQ',
      text4_2: '(Air Quality)',
      text4_3: 'Sensors',
      text5: 'No.of Lights',
      text6_1: 'No.of HCL',
      text6_2: '(Humanized Circadian Lights)',
      text7: 'No.of InGate',
      text8: 'Indoor environment index',
      text9: 'Average air quality · Today',
      text10: 'The Week',
      text11: 'Temperature',
      text12: 'Humidity',
      text13: 'HCHO',
      text14: 'Outdoor environment index',
      text15: 'Wind speed',
      text16: 'Rainfall',
      text17: 'Air pressure',
      text18: 'Visibility',
      text19: 'Alerts',
      text20: 'Current total abnormality',
      text21: 'Custom',
      // text22:'Abnormality Detected',
      text23: 'No. of resolved abnormality (Last 7 days)',
      text24: 'Device abnormality',
      text25: 'Abnormality is being handled',
      text26: 'Average indoor temperature',
      text27: 'Day',
      text28: 'Month',
      text29: 'Year',
      text30: 'Hotel overview',
      text31: 'More',
      text32: 'Lights',
      text33: 'HCL lights',
      text34: 'Sensor',
      text35: 'Air purifiers',
      text36: 'Device abnormality',
      text37: 'Rooms',
      text38: 'In-room AQI',
      text39: 'search for hotel name',
      text40: 'Indoor average',
      text41: '(Current)',
      text42: '/Indoor average',
      text43: 'Day',
      text44: 'Week',
      text45: 'Month',
      text46: 'TIPS:',
      text47: 'Air Quality Parameter',
      text48: 'SI Unit',
      text49: 'Outdoor AQI',
      text50: 'Excellent',
      text51: 'Good',
      text52: 'Fair',
      text53: 'school journal',

      text54: 'Classroom lights (online / total)',
      text55: 'Blackboard light (online / total)',
      text56: 'Switch panel (online / total)',
      text57: 'Curtain (online / total)',

      text58: 'Site Data',
      text59: 'Plant lights',
    },
    room: {
      text1: 'Room',
      text2: 'Map',
      text3: 'Search by room number',
      text4: 'Floor plan',
      text5: 'Centralized setting',
      text6: 'Device mapping',
      text7: 'Floor plan',
      text8: 'Add device',
      text9: 'Normal equipment',
      text10: 'Lights',
      text10_: 'HCL lights',
      text11: 'AQ sensors',
      text12: 'Air purifiers',
      text13: 'AQI',
      text14: 'No Data',
      text15: 'On-line',
      text16: 'New',
      text17: 'Alerts',
      text18: 'ID',
      text19: 'Number',
      text20: 'Types',
      text21: 'Status',
      text22: 'Floor',
      text23: 'Room',
      text24: 'Copy',
      text25: 'Paste',
      text26: 'Delete',
      text27: 'Centralized setting',
      text28: 'Close',
      text29: 'Floor',
      text30: 'Room',
      text31: 'Lights intensity',
      text32: 'Lights color temperature (CCT) output',
      text33: 'Lights color output',
      text34: 'Air purifier',
      text35: 'Done',
      text36: 'Floor plan',
      text37: 'Device type',
      text38: 'Device quantity',
      text39: 'Duplicate',
      text40: 'Space',
      text41: 'Column number',
      text42: 'Name',
      text43: 'Device ID',
      text44: 'Device number',
      text45: 'Please upload picture with dimensions 1100 x 600 pixels',
      text46: 'Click here to upload floor plan picture',
      text47: 'Upload progress',
      text48: 'Current file：',
      text49: 'Upload failure',
      text50: 'Duplicate to other floors',
      text51: 'Device mapping',
      text52: 'Download excel file',
      text53: 'Upload excel file',
      text54: 'Select all devices',
      text55: 'Please upload in the format, or download the template for editing',
      text56: 'Click upload file',
      text57: 'Error prompt',
      text58: 'Verify success',
      text59: 'Download',
      text60: 'Preserve',
      text61: 'User authentication',
      text62: 'user name:',
      text63: 'password:',
      text64: 'Confirm',

      text65: 'Off-line',
      text66: 'On-line',

      text67: 'Off',
      text67_: 'Null',
      text68: 'Low',
      text69: 'Middle',
      text70: 'High',

      text71: 'Default',
      text72: 'Equidistant',
      text73: 'Matrix',
      text74: 'Gateway address',
      text75: 'Add another device',
      text76: 'Temp.',
      text77: 'RH',

      text78: 'Room setup',
      text79: 'Model',
    },
    room_light: {
      text1: 'Back',
      text2: 'Room',
      text3: 'Time zone：',
      text4: 'Current time：',
      text5: 'Wake up time：',
      text6: 'Device Management',
      text7: 'Electricity consumption',
      text8: 'History',
      text9: 'Environmental status',
      text10: 'Total time of measurement',
      text11: 'light is damaged',
      text12: 'Repair',
      text13: 'Air purifiers is damaged',
      text13_1: 'Sensor is damaged',
      text14: 'Name',
      text15: 'Device-ID',
      text16: 'HCL lights plan',
      text16_: 'Plant lights plan',
      text17: 'Edit',
      text18: 'History',
      text19: 'Lighting control',
      text20: 'Auto-HCL lights',
      text20_: 'Auto-Plant lights',
      text21: 'Always Off',
      text22: 'Manual',
      text23: 'Automation',
      text24: 'Brightness',
      text25: 'Color temperature',
      text26: 'Today Sunrise',
      text27: 'Customized Sunrise',
      text28: 'current',
      text29: 'color temp',
      text30: 'Today Sunset',
      text31: 'Customized Sunset',
      text32: 'Manual control of circadian lights',
      text33: 'Brightness',
      text34: 'Color temp',
      text35: 'Simulation test',
      text36: 'Current time',
      text37: 'Sunrise',
      text38: 'Sunset',
      text39: 'Run',
      text40: 'Device status',
      text41: 'Battery level',
      text42: 'Battery status',
      text43: 'Connectivity status',
      text44: 'Wireless Strength',
      text45: 'Device Control',
      text46: 'On / Off',
      text47: 'Connectivity status',
      text48: 'Time of use',
      text49: 'Working time of filter',
      text50: 'Master light',
      text51: 'Auto-HCL lights',
      text51_: 'Auto-Plant lights',
      text52: 'Evening relaxing mode',
      text53: 'Night light mode',
      text54: 'Wake up time and bed time setting',
      text55: 'Wake up time',
      text56: 'Bed time',
      text57: 'Model',
      text58: 'Gateway ID',
      text59: 'Normal',
      text60: 'Fault',
      text61: 'Line',
      text62: 'Bar',
      text63: 'Daily',
      text64: 'Weekly',
      text65: 'Monthly',
      text66: 'Yearly',
      text67: 'Information',
      text68: 'Management',
      text69: 'Device Information',
      text70: 'Lamp Name：',
      text71: 'NA',
      text72: 'Demo mode',
      text73: 'AQ sensors',
    },
    uvLight: {
      text1: 'Add uv light',
      text2: 'Edit uv light',

      text3: 'Device name',
      text4: 'Gateway sn',
      text5: 'Gateway serial port',
      text6: 'Device address',
      text7: 'One button open',
      text8: 'One button off',

      tableLabel1: 'Device name',
      tableLabel2: 'Device ID',
      tableLabel3: 'Floor',
      tableLabel4: 'Room',
      tableLabel5: 'Device conditions',
      tableLabel6: 'Loop 1',
      tableLabel7: 'Loop 2',
      tableLabel8: 'Loop 3',
      tableLabel9: 'Loop 4',
      tableLabel10: 'Update time',
      tableLabel11: 'More actions',

      tableText1: 'Online status',
      tableText2_1: 'Turned on',
      tableText2_0: 'Turned off',
      tableText3: 'Abnormal state',
      tableText4: 'Run',

      onlineStatusTetx1: 'off-line',
      onlineStatusTetx2: 'on-line',

      faultStatusText1: 'normal',
      faultStatusText2: 'abnormal',
    },
    lights: {
      text1: 'Delete',
      text2: 'Brightness',
      text3: 'Color temperature',
      text4: 'Refresh',
      text5: 'Add device',
      text6: 'More actions',
      text7: 'Edit',
      text8: 'History',
      text9: 'Update',
      text10: 'Select all',
      text11: 'Hardware version',
      text12: 'Firmware version',
      text13: 'Edit light',
      text14: 'Add light',
      text15: 'Chart',
      text16: 'Table',
      text17: 'Download XLS',
      text18: 'Energy consumption',
      text19: 'HCL lights',
      text20: 'Update',
      text21: 'The current version is low. Please upgrade now.',
      text22: 'Failed, please click download again',
      text23: 'Current latest version',
      text24: 'Name or device-id',
      text25: 'Voltage',
      text26: 'Current',
      text27: 'Brightness',
      text28: 'Color temperature',
      text29: 'Power consumption',
      text30: 'Network status',
      text31: 'Device conditions',
      text32: 'Update time',
      text33: 'Num',
      text34: 'Time of use (TOU)',
      text35: 'See',
      text36: 'Network',
      text37: 'Edit device',
      text38: 'Centralized setting',
      text39: 'Full-on mode',
      text40: 'Full-off mode',
      text41: 'Attend class mode',
      text42: 'Finish class mode',
      text43: 'Noon break mode',
      text44: 'Self-study mode',
      text45: 'Blackboard mode',
      text46: 'Projection mode',
      text47: 'Auto',
      text48: 'Off',
      text49: 'On',
      text50: 'Button',
      text51: 'Illuminance',
      text52: 'Read',
      text53: 'Set up',
      text54: 'Current illumination value',
      text55: 'Constant illumination value',
      text56: 'Device mode information',
      text57: 'Electricity consumption',
    },
    circadianLights: {
      text1: 'Edit HCL lights',
      text2: 'Add HCL lights',
      text3: '000000000',
      text4: '000000000',
      text5: '000000000',
      text6: '000000000',
      text7: '000000000',
      text8: '000000000',
      text9: '000000000',
      text10: '000000000',

      text11: 'Edit Plant lights',
      text12: 'Add Plant lights',
    },
    sensor: {
      text1: 'Edit sensor',
      text2: 'Add sensor',
      text3: 'Temperature Statistics',
      text4: 'Humidity Statistics',
      text5: 'CO₂ Statistics',
      text6: 'PM2.5 Statistics',
      text7: 'TVOC Statistics',
      text8: 'HCHO Statistics',
      text9: 'Connectivity',
      text10: 'PM10 Statistics',
    },
    airPurifiers: {
      text1: 'Setting',
      text2: 'Working time of equipment',
      text3: 'Working time of filter',
      text4: 'Working mode of air purifier',
      text5: 'hours',
      text6: 'Fan speed',
      text7: 'Shut Down',
      text8: 'AQI',
      text9: 'Low',
      text10: 'Middle',
      text11: 'High',
      text12: 'Manual mode',
      text13: 'Auto mode(AQ)',
      text14: 'Edit air purifiers',
      text15: 'Add air purifiers',
      text16: 'Last update time',
      text17: 'Silent mode start time',
      text18: 'Silent mode end time',
      text19: 'Working mode',
      text20: 'Input sensor threshold to set air purifier fan speed',
      text21: 'Return to zero',
      text22: 'Delay Time',
      text23: 'seconds',
      text24: 'Auto mode(stand-alone)',
      text25: 'Set Grouping',
      text26: 'A twinkle',
      text27: 'Profiles',
    },
    gateway: {
      text1: 'search by name or gateway-id',
      text2: 'Add gateway',
      text3: 'WIFI',
      text4: 'Connected device',
      text5: 'Add gateway',
      text6: 'Gateway-ID',
      text7: 'Inspection cycle',
      text8: 'Discover devices and connect',
      text9: 'Connected',
      text10: 'Not connected',
      text11: 'Unnamed',
      text12: 'No nearby devices have been found.',
      text13: 'SSID',
      text14: 'Password',
      text15: 'wifi configuration takes about 2 minutes, please be patient…',
      text16: 'Retry',
      text17: 'Successfully connected to wifi ！',
      text18: 'Switch WiFi',
      text19: 'Please connect to WiFi',
      text20: 'No Data',
      text21: 'Wifi name cannot be empty',
      text22: 'Wifi password cannot be empty',
      text23: 'Command issued successfully.',
      text24: 'Can’t connect to wifi',
      text25: 'Gateway not online',
      text26: 'Search',
      text27: 'RS-485 not connected',
      text28: '000000000',
    },
    service: {
      text1: 'All device',
      text2: 'Notification setting',
      text3: 'Maintenance staff',
      text4: 'Alert profile',
      text5: 'service',
      text6: 'Mark processing',
      text7: 'Maintenance information',
      text8: 'Cause of failure',
      text9: 'Repairman',
      text10: 'Maintenance application time',
      text11: 'Maintenance completion time',
      text12: 'Repair',
      text13: 'Repair personnel',
      text14: 'All device',
      text15: 'No maintenance',
      text16: 'Maintenance',
      text17: 'Repaired',
      text18: 'Device type',
      text19: 'Error Code',
      text20: 'Abnormality Status',
      text21: 'Add alarm profile',
      text22: 'jurisdiction',
      text23: 'Edit alarm profile',
      text24: 'View alarm profile',
      text25: 'Select type of data',
      text26: 'Set condition',
      text27: 'Set parameter',
      text28: 'Schedule',
      text29: 'New',
      text30: 'Set temperature',
      text31: 'Set CO₂',
      text32: 'Set AQI',
      text33: 'Set connectivity',
      text34: 'Everyday',
      text35: 'Add maintenance staff',
      text36: 'Edit maintenance staff',
      text37: 'Access right',
      text38: 'Assign access permission',
      text39: 'Contact number',
      text40: 'Number of sites assigned',
      text41: 'Number of people',
      text42: 'Add notification',
      text43: 'Edit notification',
      text44: 'Recipient',
      text45: 'Notify to',
      text46: 'Device',
      text47: 'All Sites',
      text48: 'Configured',
      text49: 'Not configured',
      text50: 'Site',
      text51: 'Contact number',
      text52: 'Enable',
      text53: 'disconnect',

      text54: 'Filter out of service time',
      text55: 'Abnormal temperature',
      text56: 'Carbon dioxide anomaly',
      text57: 'AQI abnormality',
      text58: 'Offline exception',

      text59: 'Case status',
      text60: 'Still open',
      text61: 'Closed',
      text62: 'Set pm2.5',
      text63: 'Set pm10',
      text64: 'Set TVOC',
      text65: 'Set HCHO',
      text66: 'More actions',
      text67: 'Notification chann',
      text68: 'Close',
    },
    activityHistory: {
      text1: 'User activity',
      text2: 'User',
      text3: 'Activites',
      text4: 'Log time',
      text5: 'Description',
      text6: '000000000',
      text7: '000000000',
      text8: '000000000',
      text9: '000000000',
      text10: '000000000',
      text11: '000000000',
    },
    userManagement: {
      text1: 'Add User',
      text2: 'System admin',
      text3: 'Hotel managers',
      text4: 'Hotel users',
      text5: 'User profile',
      text6: 'User profile',
      text7: 'Selected authority',
      text8: 'Hotel manager',
      text9: 'Hotel user',
      text10: 'Customer account',
      text11: 'Account name is 4 to 20 characters long',
      text12: 'Account-ID is 4 to 20 characters long',
      text13: 'Account name',
      text14: 'Contact number',
      text15: 'Account type',
      text16: 'Activate',

      text17: 'Site managers',
      text18: 'Site users',
      text19: 'Site manager',
    },
    siteManagement: {
      text1: 'Add site',
      text2: 'Add school',
      text3: 'Upload HCL algorithm',
      text4: 'Add building',
      text5: 'Add floor',
      text6: 'Add room',
      text7: 'Edit floor',
      text8: 'Delete floor',
      text9: 'Edit hotel',
      text10: 'Edit school',
      text11: 'Address',
      text12: 'Longitude',
      text13: 'Latitude',
      text14: 'Edit building',
      text15: 'Building Name',
      text16: 'single layer',
      text17: 'multichamber',
      text18: 'Closing floor',
      text19: 'Start floor',
      text20: 'Edit room',
      text21: 'Room name',
      text22: 'Room ID',
      text23: 'SN',
      text24: 'Edit logo',
      text25: 'Please upload PNG, JPG format pictures no more than 2m',
      text26: 'Click upload hotel logo',
      text27: 'Upload progress',
      text28: 'Upload success',
      text29: 'Upload failure',
      text30: 'Setting alarm profile',
      text31: 'Alarm profile',
      text32: 'Please enter the correct latitude and longitude',
      text33: 'Unrecognized, please change the search content',
      text34: 'No building or floor selected',
      text35: 'No building selected',
      text36: 'Address cannot be empty',
      text37: 'Longitude cannot be empty',
      text38: 'Latitude cannot be empty',
      text39: 'Upload HCL algorithm',
      text40: 'Upload HCL algorithm',
      text41: 'Upload HCL algorithm',
      text42: 'Please upload in the format, or download ',
      text43: ' the template',
      text44: ' for editing',
      text45: 'Upload by',
      text46: 'Upload time',
      text47: 'Upload',

    },
    sideBar_: {
      text1: '000000000',
      text2: '000000000',
      text3: '000000000',
      text4: '000000000',
      text5: '000000000',
      text6: '000000000',
      text7: '000000000',
      text8: '000000000',
      text9: '000000000',
      text10: '000000000',
      text11: '000000000',
    },
    message: {
      text1: 'System hints',
      text2: 'Confirm',
      text3: 'Do you confirm to delete?',
      text4: 'Prompt',
      text5: 'Confim',
      text6: 'Cancel',
      text7: 'Undelete',
      text8: 'Cannot upgrade',
      text9: 'Devices not online',
      text10: ' is the latest version',
      text11: 'Please select the devices',
      text12: 'Lamp:',
      text13: ' not online',
      text14: ' not bound to gateway',
      text15: 'Device not bound to gateway',
      text16: 'Are you sure you want to delete the device? After the device is deleted, the historical data will also be deleted. Please pay attention to backup',
      text17: 'Warning',
      text18: 'Canceled',
      text19: 'HCL lights name:',
      text19_: 'Plant lights name:',
      text20: 'Sensor name:',
      text21: 'Air purifiers name:',
      text22: 'Device name:',
      text23: 'Unchecked',
      text24: 'Are you sure you want to delete the gateway?',
      text25: 'Are you sure you want to delete the Logs?',
      text26: 'Are you sure to mark and handle the current fault?',
      text27: 'Are you sure you want to delete the alarm profile?',
      text28: 'Are you sure you want to delete the repair personnel?',
      text29: 'Upload the picture only in JPG, PNG format!',
      text30: 'The size of uploaded image cannot exceed 2MB!',
      text31: 'Are you sure you want to delete the users?',
      text32: 'Are you sure you want to delete the room?',
      text33: 'Are you sure you want to delete the build?',
      text34: 'Are you sure you want to delete the floor?',
      text35: 'Are you sure you want to delete the hotel?',
      text36: 'Are you sure you want to delete the plan?',
      text37: 'Bed time should be 4 hours later than wake—up time',
      // text37:'Wake-up time should be 3 hours later than sleeping time',
      text38: 'Please wait for the previous operation to return',
      text39: 'Are you sure to cancel the fault?',
      text40: 'Are you sure you want to clear the working hours?',

      delDevText: 'Confirm to delete device from database?',
    }
  }
}